import React from 'react';
const testimonials = [{
  name: 'Francesca M.',
  role: 'Insegnante di 1ª classe',
  city: 'Milano',
  text: 'Finalmente la musica non è più un problema! I miei bambini di 1ª adorano le attività ritmiche e io non perdo più tempo a cercare schede.',
  stars: 5
}, {
  name: 'Giulia R.',
  role: 'Insegnante di 5ª classe',
  city: 'Roma',
  text: 'La programmazione per il PTOF è perfetta. La Dirigente è rimasta colpita dalla precisione degli obiettivi. Consiglio vivamente!',
  stars: 5
}, {
  name: 'Chiara L.',
  role: 'Insegnante di sostegno',
  city: 'Napoli',
  text: 'Le slide per la LIM con le note colorate sono fantastiche. Anche i miei alunni con DSA hanno imparato a leggere il pentagramma in un attimo.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-226">
      <div className="max-w-5xl mx-auto" data-id="element-227">
        <div className="text-center mb-14" data-id="element-228">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-229">
            Cosa dicono le insegnanti
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-230">
            Oltre <span className="text-primary font-bold" data-id="element-231">15.000 docenti</span>{' '}
            hanno già scelto le risorse EduLabs
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-232">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-233">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-234"></div>

              {/* Stars */}
              <div className="flex items-center gap-0.5 relative z-10" data-id="element-235">
                {Array.from({
              length: t.stars
            }).map((_, j) => <span key={j} className="text-secondary text-lg" data-id="element-236">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-237">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-238">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-239">
                  <span className="text-sm font-bold text-primary" data-id="element-240">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-241">
                  <p className="text-text-main font-bold text-sm" data-id="element-242">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-243">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}